export default __webpack_public_path__ + "static/RunLeft6-d52c5b397ac33c6de5a9477e46e4ebe5.mp3";